import { render, staticRenderFns } from "./Applicationstatus.vue?vue&type=template&id=2db56d4e&scoped=true&"
import script from "./Applicationstatus.vue?vue&type=script&lang=js&"
export * from "./Applicationstatus.vue?vue&type=script&lang=js&"
import style0 from "./Applicationstatus.vue?vue&type=style&index=0&id=2db56d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db56d4e",
  null
  
)

export default component.exports